<div
  style="
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  "
>
  <div>
    <div
      *ngIf="formControl.value as rule"
      style="display: flex; align-items: center"
    >
      <p style="margin-top: 0; margin-right: 10px">
        {{ "common.name" | translate }} : <span>{{ rule.name }}</span>
      </p>
      <a
        class="button-ghost"
        [routerLink]="['/extensions', 'split-order-rules', rule.id]"
        target="_blank"
      >
        {{ "common.details" | translate }}
        <clr-icon shape="link"></clr-icon>
      </a>
    </div>
  </div>
</div>
<!-- <select [formControl]="formControl" [compareWith]="compareFn">
  <option [ngValue]="null">Select an Artist...</option>
  <option *ngFor="let item of artists$ | async" [ngValue]="item">
    <h3>{{ item.code }} - {{ item.name }}</h3>
  </option>
</select> -->

<ng-select
  [items]="rules$ | async"
  appendTo="body"
  bindLabel="name"
  [addTag]="false"
  [multiple]="false"
  [hideSelected]="true"
  [trackByFn]="trackByFn"
  [minTermLength]="0"
  [loading]="isLoading"
  [typeahead]="input$"
  [formControl]="formControl"
>
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <span class="item-row">
      <clr-icon shape="user" class="is-solid"></clr-icon
      ><span class="mx-1">{{ item.name }}</span>
    </span>
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    <span class="item-row">
      <clr-icon shape="user" class="is-solid"></clr-icon
      ><span class="mx-1">{{ item.name }}</span>
    </span>
  </ng-template>
</ng-select>
